import React from 'react';

function ProgressBar({ current = 0, total = 10 }) {
    const progress = (current / total) * 100;

    return (
        <div className="relative w-[280px] h-[30px] md:w-full md:h-[65px] bg-[#151220] shadow-black rounded-lg md:rounded-2xl overflow-hidden" style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>
            <div
                className="absolute top-0 left-0 h-full bg-[#6F33A9]"
                style={{
                    width: `${progress}%`,
                    transition: 'width 0.3s ease-in-out',
                }}
            ></div>

            <div className="absolute inset-0 flex justify-center items-center">
                <h2 className="text-1xl md:text-40 text-white text-center whitespace-nowrap">
                    You have 0/?? NFTs
                </h2>
            </div>
        </div>
    );
}

export default ProgressBar;
